import { createApp } from 'vue';
import 'normalize.css';
import '@assets/css/index.css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import App from './App.vue';
import router from '@infra/router';
import VueGtag from 'vue-gtag';
import { createPinia } from 'pinia';
import VueObserveVisibility from 'vue3-observe-visibility';
// import * as Sentry from '@sentry/vue';

const app = createApp(App);
const pinia = createPinia();

document.title = import.meta.env.VITE_APP_CC_NAME;

if (import.meta.env.VITE_APP_NODE_ENV === 'production') {
  app.use(
    VueGtag,
    {
      config: {
        id: import.meta.env.VITE_APP_GA,
        params: {
          anonymize_ip: true,
        },
      },
    },
    router
  );
}

window.addEventListener('vite:preloadError', (event: Event) => {
  event.preventDefault();
  window.location.reload();
});

app.use(router);
app.use(pinia);
app.use(VueObserveVisibility);
app.mount('#app');
